/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalEhrDocumentRelationType } from './ExternalEhrDocumentRelationType';
import {
    ExternalEhrDocumentRelationTypeFromJSON,
    ExternalEhrDocumentRelationTypeFromJSONTyped,
    ExternalEhrDocumentRelationTypeToJSON,
    ExternalEhrDocumentRelationTypeToJSONTyped,
} from './ExternalEhrDocumentRelationType';

/**
 * 
 * @export
 * @interface ExternalEhrDocument
 */
export interface ExternalEhrDocument {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    external_ehr_document_id?: string;
    /**
     * 
     */
    relation_type?: ExternalEhrDocumentRelationType;
    /**
     * 
     */
    relation_id?: string;
    /**
     * 
     */
    created_at?: string;
}



/**
 * Check if a given object implements the ExternalEhrDocument interface.
 */
export function instanceOfExternalEhrDocument(value: object): value is ExternalEhrDocument {
    return true;
}

export function ExternalEhrDocumentFromJSON(json: any): ExternalEhrDocument {
    return ExternalEhrDocumentFromJSONTyped(json, false);
}

export function ExternalEhrDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEhrDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'type': json['type'] == null ? undefined : json['type'],
        'external_ehr_document_id': json['external_ehr_document_id'] == null ? undefined : json['external_ehr_document_id'],
        'relation_type': json['relation_type'] == null ? undefined : ExternalEhrDocumentRelationTypeFromJSON(json['relation_type']),
        'relation_id': json['relation_id'] == null ? undefined : json['relation_id'],
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
    };
}

export function ExternalEhrDocumentToJSON(json: any): ExternalEhrDocument {
    return ExternalEhrDocumentToJSONTyped(json, false);
}

export function ExternalEhrDocumentToJSONTyped(value?: ExternalEhrDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'type': value['type'],
        'external_ehr_document_id': value['external_ehr_document_id'],
        'relation_type': ExternalEhrDocumentRelationTypeToJSON(value['relation_type']),
        'relation_id': value['relation_id'],
        'created_at': value['created_at'],
    };
}

